export default __webpack_public_path__ + "static/media/processing.2b266081.gif";